import React from 'react';
import PropTypes from 'prop-types';

const CardImage = ({
    url,
    hasMedia,
    option = 'top',
    size,
    className,
    width,
    height,
    deleteMedia,
    ...otherProps
}) => {
    const baseClass = 'gds-card__img-container',
        optionClass = option ? `${baseClass}--${option}` : '',
        sizeClass = size ? `${baseClass}--${size}` : '';

    const classNames = `${baseClass} ${optionClass} ${sizeClass} ${className}`;

    return (
        <div className={classNames} {...otherProps}>
            {hasMedia && (
                <img
                    className="gds-card__img"
                    src={url}
                    width={width}
                    height={height}
                />
            )}
            {hasMedia && deleteMedia && (
                <button
                    type="button"
                    className="gds-circular-button -m-r-1 gds-circular-button--xs gds-circular-button--danger -m-a-1"
                    style={{ position: 'absolute', bottom: '0', right: '0' }}
                    onClick={deleteMedia}
                >
                    <i className="fa fa-fw fa-trash-alt" />
                </button>
            )}
            {!hasMedia && (
                <div
                    className="gds-card__img gds-flex -text-center gds-flex--justify-center gds-flex--direction-col"
                    style={{
                        width,
                        height,
                        alignItems: 'center',
                        alignContent: 'center',
                        minHeight: '150px',
                    }}
                >
                    <i className="fal fa-images" />
                    <p>No media available</p>
                </div>
            )}
            <div className="gds-card__img-helper" />
        </div>
    );
};

CardImage.propTypes = {
    url: PropTypes.string,
    option: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    hasMedia: PropTypes.bool,
    deleteMedia: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleClick: PropTypes.func,
};

export default CardImage;
